import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import moment from "moment-timezone";

import PaginationControl from "components/tools/pagination-control";
import { Breadcrumb, Container, RowWrapper } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import BookingsApi from "api/bookings-api";
import ReviewsApi from "api/reviews-api";
import UniversityApi from "api/university-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";
import { ERoles } from "../../types/enums";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ReviewsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useBodyBackground("white");
    let reviews = useStorageListener((store) => {
        const { id: userId } = _.get(store, "user", {});
        const myDormitoriesIds = Object.values(_.get(store, "dormitories", {}))
            .filter((dormitory: any) => dormitory.userId === userId)
            .map((dormitory: any) => dormitory.id);
        // const reviews = _.get(store, "reviews", []).filter((review) => myDormitoriesIds.includes(review.dormitoryId));
        let reviews = _.get(store, "reviews", []);
        return reviews;
    });

    let myDormitoriesIds = useStorageListener((store) => {
        const { id: userId } = _.get(store, "user", {});
        const myDormitoriesIds = Object.values(_.get(store, "dormitories", {}))
            .filter((dormitory: any) => dormitory.userId === userId)
            .map((dormitory: any) => dormitory.id);
        // const reviews = _.get(store, "reviews", []).filter((review) => myDormitoriesIds.includes(review.dormitoryId));
        return myDormitoriesIds;
    });

    console.log("myDormitoriesIds = ", myDormitoriesIds);

    reviews = reviews.sort((a, b) => (+b.timestamp) - (+a.timestamp));
    reviews = reviews.map(x => {
        let userName = (x.user == undefined) ? undefined : x.user.name;
        return {
            ...x,
            userName: userName
        };
    });
    let relevantReviews = reviews.filter((review) => myDormitoriesIds.includes(review.dormitoryId));
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    console.log("role = ", role);
    if (role != "uni-admin") {
        relevantReviews = reviews;
    }

    // const paginationResult = usePagination(reviews, { perPage: 10 });
    const paginationResult = usePagination(relevantReviews, { perPage: 10 });
    const { visibleItems } = paginationResult;

    useEffect(() => {
        BookingsApi.getMyBookings();
        ReviewsApi.getAllReviews();
        UniversityApi.getAllUniversitiesData();
    }, []);

    return (
        <Container extra={`align-items: flex-start;`} className={"requests_page"}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("dwvtcnksbf9")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper extra={`h1 { margin: 0; };`}>
                <h1>{t("xezpz5c4d2")}</h1>
            </RowWrapper>
            <Table
                name="reviews"
                withPagination={false}
                columns={[
                    // { name: "timestamp", label: "#", extra: `flex: 2;` },
                    { name: "userName", label: "Кто", extra: `flex: 2;` },
                    {
                        name: "timestamp",
                        label: "Дата",
                        extra: `flex: 1.5;`,
                        transform: ({ row }) => moment(_.get(row, "timestamp")).format("DD.MM.YYYY")
                    },
                    { name: "rating", label: "Оценка", extra: `flex: 1;` },
                    { name: "text", label: "Комментарий", extra: `flex: 5;` },
                    { name: "uniComment", label: "Комментарий ВУЗа", extra: `flex: 5;` },
                    {
                        name: "published",
                        label: "Пуликация",
                        extra: `flex: 2;`,
                        transform: ({ row }) => (row.published ? "Опубликован" : "Скрыт")
                    },
                    // { name: "published", label: "Публикация", extra: `flex: 3;`, transform: ({ row }) => JSON.stringify(row.publised) },
                    {
                        name: "removeButton",
                        label: ``,
                        extra: `flex: 0.5;`,
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            src: "trash-can"
                        },
                        onCellClick: ({ row }) => {
                            console.log("onCellClick: row = ", row);
                            ModalsService.showModality({
                                title: "Удалить отзыв?",
                                description: "Вы уверены, что хотите удалить отзыв?",
                                confirmButton: {
                                    children: "Да",
                                    onClick: () => {
                                        ReviewsApi.deleteReview(row.id);
                                    }
                                },
                                cancelButton: {
                                    children: "Нет"
                                }
                            });
                        }
                    },

                    (role == "uni-admin") ? null :
                        {
                            name: "publishButton",
                            label: ``,
                            extra: `flex: 2;`,
                            cell: {
                                type: "button",
                                children: "Опубликовать"
                            },
                            onCellClick: ({ row }) => {
                                console.log("onCellClick: publishButton: row = ", row);
                                ReviewsApi.updateReview({ id: row.id, published: true });
                                // ModalsService.showModality({
                                //     title: "Публикация отзыва",
                                //     description: "Выберите, опубликовать или скрыть отзыв",
                                //     confirmButton: {
                                //         children: "Опубликовать",
                                //         onClick: () => {
                                //             ReviewsApi.updateReview({ ...row, published: true });
                                //         }
                                //     },
                                //     cancelButton: {
                                //         children: "Скрыть",
                                //         onClick: () => {
                                //             ReviewsApi.updateReview({ ...row, published: false });
                                //         }
                                //     }
                                // });
                            }
                        },
                    {
                        name: "publishButton",
                        label: ``,
                        extra: `flex: 2;`,
                        cell: {
                            type: "button",
                            children: "Оставить комментарий"
                        },
                        onCellClick: ({ row }) => {
                            // console.log('onCellClick: publishButton: row = ', row);
                            let comment = window.prompt("Введите комментарий");
                            if (comment == undefined || comment == "") {
                                toast.error("Комментарий не может быть пустым");
                                return;
                            }
                            ReviewsApi.updateReview({ id: row.id, uniComment: comment });
                            // ModalsService.showModality({
                            //     title: "Публикация отзыва",
                            //     description: "Выберите, опубликовать или скрыть отзыв",
                            //     confirmButton: {
                            //         children: "Опубликовать",
                            //         onClick: () => {
                            //             ReviewsApi.updateReview({ ...row, published: true });
                            //         }
                            //     },
                            //     cancelButton: {
                            //         children: "Скрыть",
                            //         onClick: () => {
                            //             ReviewsApi.updateReview({ ...row, published: false });
                            //         }
                            //     }
                            // });
                        }
                    },
                    {
                        name: "text",
                        label: ``,
                        extra: `flex: 0.5;`,
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            src: "info"
                        },
                        onCellClick: ({ row }) => {
                            // redirect

                            navigate(`/dormitory/${row.dormitoryId}`);
                        }
                    }
                ].filter(x => (x != undefined))}
                rows={visibleItems}
                extra={`margin-top: 56px;`}
            />
            <PaginationControl pagination={paginationResult} />
        </Container>
    );
};

export default ReviewsPage;
